import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Phone } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { ScheduleButton } from '@/components/ScheduleButton';

export const StickyNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 100px and not dismissed
      if (window.scrollY > 100 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 100) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-slide-up">
      <div className="max-w-sm mx-auto bg-primary text-primary-foreground rounded-lg shadow-strong p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1">
            <Phone className="w-5 h-5" />
            <div>
              <div className="font-medium text-sm">
                {language === 'en' ? 'Ready to Optimize Your Pricing?' : '¿Listo para Optimizar Tus Precios?'}
              </div>
              <div className="text-xs opacity-90">
                {language === 'en' ? 'Book free diagnostic session' : 'Agenda diagnóstico gratuito'}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <ScheduleButton
              locale={language}
              variant="outline"
              size="sm"
              source="sticky"
              intent="demo"
              className="sticky-cta bg-primary-foreground text-primary border-primary-foreground hover:bg-primary-foreground/90"
            >
              {language === 'en' ? 'Book Now' : 'Reservar'}
            </ScheduleButton>
            <Button
              size="sm"
              variant="ghost"
              className="text-primary-foreground hover:bg-primary-foreground/10 p-1 h-auto"
              onClick={handleDismiss}
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};